import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoWhite from '../assets/logo-white.svg';  // Logo untuk mobile
import logoBlack from '../assets/logo.svg';  // Logo untuk desktop
import { AiFillInstagram, AiFillTikTok } from "react-icons/ai";

const Footer = () => {
    // State untuk menyimpan informasi perangkat
    const [deviceType, setDeviceType] = useState("desktop");

    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();

        // Deteksi apakah perangkat mobile atau desktop
        if (userAgent.includes("iphone") || userAgent.includes("android")) {
            setDeviceType("mobile");
        } else if (userAgent.includes("ipad") || userAgent.includes("tablet")) {
            setDeviceType("tablet");
        } else {
            setDeviceType("desktop");
        }
    }, []);

    // Conditional rendering berdasarkan jenis perangkat
    const isMobile = deviceType === "mobile";

    return (
        <footer className={`footer ${isMobile ? 'mobile-footer' : 'desktop-footer'}`}>
            <div className="footer-content">
                <div className="footer-logo">
                    {/* Ganti logo sesuai perangkat */}
                    <img
                        src={isMobile ? logoWhite : logoBlack}
                        alt="Mein Logo"
                        className="logo-brand"
                    />
                    <p style={{ color: isMobile ? '#fff' : '#7d7d7d' }}>
                        {/* Ganti warna teks sesuai perangkat */}
                        Mein offers timeless basics for men, combining modern comfort with classic style. Our pieces are crafted for everyday wear, focusing on quality, durability, and versatility to fit any occasion.
                    </p>
                </div>
                <div className="footer-links">
                    <div className="footer-column">
                        <h4 style={{ color: isMobile ? '#fff' : '#000' }}>SHOP</h4>
                        <ul>
                            <li>
                                <Link to="/product" className="collection" style={{ textDecoration: 'none', color: isMobile ? '#ffff' : '#7d7d7d' }}>First Collection</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-column">
                        <h4 style={{ color: isMobile ? '#fff' : '#000' }}>FOLLOW US</h4>
                        <div className="social-icons">
                            <a href="https://www.instagram.com/meinwear.id" target="_blank" rel="noopener noreferrer">
                                <AiFillInstagram size={24} style={{ marginRight: '10px', color: isMobile ? '#fff' : '#000' }} />
                            </a>
                            <a href="https://www.tiktok.com/@mein.essential" target="_blank" rel="noopener noreferrer">
                                <AiFillTikTok size={24} style={{ marginRight: '10px', color: isMobile ? '#fff' : '#000' }} />
                            </a>
                        </div>
                    </div>
                    <div className="footer-column">
                        <h4 style={{ color: isMobile ? '#fff' : '#000' }}>SUPPORT</h4>
                        <ul>
                            <li style={{ color: isMobile ? '#fff' : '#7d7d7d' }}>FAQs</li>
                            <li style={{ color: isMobile ? '#fff' : '#7d7d7d' }}>Cookie Policy</li>
                            <li style={{ color: isMobile ? '#fff' : '#7d7d7d' }}>Terms of Use</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p style={{ color: isMobile ? '#fff' : '#7d7d7d' }}>Copyright ©2024 Mein Essential. All rights reserved</p>
            </div>
        </footer>
    );
};

export default Footer;
